import { Box, withStyles } from '@material-ui/core';

export const WrapperBox = withStyles(() => ({
  root: {
    width: '100%',
    maxWidth: 400,
  },
}))(Box);

export const NotificationBox = withStyles(({ spacing, breakpoints }) => ({
  root: {
    marginBottom: spacing(1.2),
    [breakpoints.up('sm')]: {
      marginBottom: 0,
      position: 'fixed',
      top: 0,
      left: '50%',
      transform: `translate(-50%, -${spacing(1)}px)`,
    },
  },
}))(Box);
